import React, {useState, useEffect} from "react";

const InputErrorMessage = (props) => {
    return (
        <span className="invalid-feedback">{ props.message }</span>
    );
};

export default InputErrorMessage;